<template>
  <div>
    <va-modal
      class="evollu-form"
      :value="showModal"
      id="createAccessCodesModal"
      ref="createAccessCodesModal"
      size="large"
      :showOkay="true"
      :okText="this.$t('users.create')"
      :cancelText="$t('leads.back')"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :ok-disabled="!canSubmit"
      :noOutsideDismiss="false">

      <div slot="header" class="d-flex justify--space-between">
        <span>
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.$t('biosigns.accessCodes.createCodes')}}</b></span>
        </span>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div>
            <label class="form-label">{{$t('iframe.table_headings.client')}}:</label>
            <multiselect
              v-model="selectedClient"
              :options="clientOptions"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('iframe.table_headings.client')"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="clientOptions.length <= 1">
              <template slot="clear">
                <span class="multiselect__clear" v-if="selectedClient"
                      @mousedown.prevent.stop="selectedClient = null"></span>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div>
            <label class="form-label">Hash:</label>
            <multiselect
              v-model="selectedHash"
              :options="filteredFlows"
              track-by="id"
              label="hash"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="Hash"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="selectedClient === null">
              <template slot="clear">
                <span class="multiselect__clear" v-if="selectedHash"
                      @mousedown.prevent.stop="selectedHash = null"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <form class="evollu-form">
        <div class="row col-12 p-0">
          <div class="col-6 col-md-6 mb-2">
            <va-input
              id="quantity"
              type="number"
              v-model="form.quantity"
              :label="$t('biosigns.accessCodes.formCreation.quantity')"
              :placeholder="$t('biosigns.accessCodes.formCreation.quantity')"
              @input="quantityError = null"
            />

            <small v-show="quantityError !== null" class="help text-danger">
              {{ quantityError }}
            </small>
          </div>

          <div class="col-6 col-md-6 mb-4">
            <div class="form-group form-group-agenda" :class="{'has-error': validUntilError !== null}">
              <div class="input-group">
                <va-date-picker
                  class="w-100"
                  v-model="form.validUntil"
                  @input="onValidUntilInput"
                  :placeholder="$t('biosigns.accessCodes.formCreation.validUntil')"
                  :label="$t('biosigns.accessCodes.formCreation.validUntil')"
                  :config="{
                          enableTime: false,
                          dateFormat: 'Y-m-d',
                          minDate: moment().tz('Europe/Lisbon').startOf('day').toDate(),
                          //maxDate: moment().tz('Europe/Lisbon').add(2, 'months').toDate()
                        }"/>
                <i class="bar"></i>
                <small v-show="validUntilError !== null" class="help text-danger">
                  {{ validUntilError }}
                </small>
              </div>
            </div>
          </div>
        </div>


      </form>

    </va-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { IframeService } from '@/api/IframeService';
import moment from 'moment-timezone';

export default {
  components: { Multiselect },
  mixins: [ClustersAndEntitiesMixin, MultiselectLabelFormatter],
  props: {
    clientOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      isSubmitting: false,
      selectedClient: null,
      selectedHash: null,
      filteredFlows: [],
      flows: [],
      form: {
        quantity: null,
        validUntil: null,
        testFlowHash: null,
      },
      quantityError: null,
      validUntilError: null,
      testFlowHashError: null

    }
  },
  async mounted() {
    this.showModal = true
    this.flows = await IframeService.getAllFlowsUnpaginated()
  },
  methods: {
    onValidUntilInput: function (date) {
      this.form.validUntil = moment(date, 'YYYY-MM-DD').tz('Europe/Lisbon').endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    handleSubmit: function () {
      const form = {...this.form}
      form.quantity = parseInt(this.form.quantity)
      form.validUntil = this.$options.filters.utcTime(this.form.validUntil)

      IframeService.createBiosignalsAccessCodes(form).then(res => {
        this.isSubmitting = true
        this.showToast(this.$t('biosigns.accessCodes.formCreation.success'), this.$store.state.successToastOptions)
        this.$emit('created', res.data)
        this.showModal = false
      }).catch(err => {
        this.showToast(this.$t('auth.tfa.errors.generic'), this.$store.state.errorToastOptions)
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  },
  computed: {
    canSubmit() {
      return this.form.quantity !== null &&
        this.form.quantity !== '' &&
        this.form.quantity > 0 &&
        this.form.testFlowHash !== null &&
        this.form.testFlowHash !== '' &&
        this.form.validUntil &&
        //moment(this.form.validUntil).tz('Europe/Lisbon').isSameOrBefore(moment().tz('Europe/Lisbon').add(2, 'months')) &&
        moment(this.form.validUntil).tz('Europe/Lisbon').isAfter(moment().tz('Europe/Lisbon'))
    }
  },
  watch: {
    selectedClient: function (value) {
      if(value) {
        this.filteredFlows = this.flows.filter(flow => flow.clientId === value.id)
      } else {
        this.selectedHash = null
        this.filteredFlows = []
      }
    },
    selectedHash: function (value) {
      if(value) {
        this.form.testFlowHash = value.hash
      } else {
        this.form.testFlowHash = null
      }
    },
    'form.quantity': function (value) {
        if( !value || value < 1) {
          this.quantityError = this.$t('biosigns.accessCodes.formCreation.quantityError')
        } else {
          this.quantityError = null
          this.form.quantity = parseInt(value)
        }
      }
    }

}

</script>

<style scoped lang="scss">

</style>
